import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'folder/Inbox',
  //   pathMatch: 'full',
  // },
  // {
  //   path: 'folder/:id',
  //   loadChildren: () =>
  //     import('./folder/folder.module').then((m) => m.FolderPageModule),
  // },
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        (m) => m.DashboardPageModule
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then((m) => m.DashboardPageModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./pages/signup/signup.module').then((m) => m.SignupPageModule),
  },
  {
    path: 'properties',
    loadChildren: () =>
      import('./pages/properties/properties.module').then(
        (m) => m.PropertiesPageModule
      ),
  },
  {
    path: 'properties/applicant/:propertyID',
    loadChildren: () =>
      import ('./pages/properties/applicant/applicant.module').then(
        (m) => m.ApplicantPageModule
      ),
  },
  {
    path: 'tenants',
    loadChildren: () =>
      import('./pages/tenants/tenants.module').then((m) => m.TenantsPageModule),
  },
  {
    path: 'invoices',
    loadChildren: () =>
      import('./pages/invoices/invoices.module').then(
        (m) => m.InvoicesPageModule
      ),
  },
  {
    path: 'reminders',
    loadChildren: () =>
      import('./pages/reminders/reminders.module').then(
        (m) => m.RemindersPageModule
      ),
  },
  {
    path: 'tenant-requests',
    loadChildren: () =>
      import('./pages/tenant-requests/tenant-requests.module').then(
        (m) => m.TenantRequestsPageModule
      ),
  },
  {
    path: 'lease',
    loadChildren: () =>
      import('./pages/lease/lease.module').then((m) => m.LeasePageModule),
  },
  {
    path: 'tasks',
    loadChildren: () =>
      import('./pages/tasks/tasks.module').then((m) => m.TasksPageModule),
  },
  {
    path: 'selection',
    loadChildren: () =>
      import('./modals/selection/selection.module').then(
        (m) => m.SelectionPageModule
      ),
  },
  {
    path: 'expenses',
    loadChildren: () =>
      import('./pages/expenses/expenses.module').then(
        (m) => m.ExpensesPageModule
      ),
  },
  {
    path: 'about-us',
    loadChildren: () =>
      import('./about-us/about-us.module').then((m) => m.AboutUsPageModule),
  },
  {
    path: 'hf-terms',
    loadChildren: () =>
      import('./hf-terms/hf-terms.module').then((m) => m.HfTermsPageModule),
  },
  {
    path: 'hf-policy',
    loadChildren: () =>
      import('./hf-policy/hf-policy.module').then((m) => m.HfPolicyPageModule),
  },
  {
    path: 'transaction-reports',
    loadChildren: () =>
      import('./pages/transaction-reports/transaction-reports.module').then(
        (m) => m.TransactionReportsPageModule
      ),
  },
  {
    path: 'payments',
    loadChildren: () =>
      import('./pages/payments/payments.module').then(
        (m) => m.PaymentsPageModule
      ),
  },
  {
    path: 'add-task',
    loadChildren: () =>
      import('./pages/add-task/add-task.module').then(
        (m) => m.AddTaskPageModule
      ),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'map',
    loadChildren: () =>
      import('./pages/map/map.module').then((m) => m.MapPageModule),
  },
  {
    path: 'wishlist',
    loadChildren: () =>
      import('./pages/wishlist/wishlist.module').then(
        (m) => m.WishlistPageModule
      ),
  },
  {
    path: 'property-confirm-pay',
    loadChildren: () =>
      import('./pages/property-confirm-pay/property-confirm-pay.module').then(
        (m) => m.PropertyConfirmPayPageModule
      ),
  },

  {
    path: 'templates',
    loadChildren: () =>
      import('./pages/templates/templates.module').then(
        (m) => m.TemplatesPageModule
      ),
  },
  {
    path: 'setting',
    loadChildren: () => import('./pages/setting/setting.module').then( m => m.SettingPageModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('./pages/notification/notification.module').then( m => m.NotificationPageModule)
  },
  {
    path: 'help-support',
    loadChildren: () => import('./pages/help-support/help-support.module').then( m => m.HelpSupportPageModule)
  },
  {
    path: 'subscription',
    loadChildren: () => import('./pages/subscription/subscription.module').then( m => m.SubscriptionPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule)
  }, 
  {
    path: 'payment',
    loadChildren: () => import('./pages/payment/payment-routing.module').then(m => m.PaymentPageRoutingModule)
  },
  {
    path: 'maintenance',
    loadChildren: () =>
      import('./pages/maintenance/maintenance.module').then(
        (m) => m.MaintenancePageModule
      ),
  },
  {
    path: 'maintenance/create-request',
    loadChildren: () =>
      import('./pages/maintenance/maintenance-create-request/maintenance-create-request.module').then(
        (m) => m.MaintenanceCreateRequestPageModule
      ),
  },
  {
    path: 'auto-rent',
    loadChildren: () => import('./auto-rent/auto-rent.module').then( m => m.AutoRentPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
